/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import loader from "assets/images/loader.gif";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";

import innerCover from "assets/images/banners/banner-iqac.webp";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import * as React from "react";
// Material Kit 2 React examples
import { useQuery } from "@apollo/client";
import { IQAC_DATAS } from "../../../graphql/query/iqac";

const NameText = styled("li")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  fontWeight: "400",
  alignItems: "center",
  paddingLeft: "5px",
  marginLeft: "50px",
  justifyContent: "center",
  listStyleType: "disc",
}));
function CriteriaWiseInCharges() {
  const [criterias, setCriterias] = React.useState([]);
  const { loading, error, data } = useQuery(IQAC_DATAS, {
    variables: {
      filterInput: {
        sortColumn: "sort_order",
        sortOrder: "asc",
        type: "Criteria Wise In Charges",
        status: true,
      },
    },
  });
  React.useEffect(() => {
    if (loading === false) {
      if (error) {
        setCriterias([]);
      } else {
        const transform = (array) =>
          Object.values(
            array.reduce((all, curr) => {
              const key = curr.criteria_type;
              (all[key] || (all[key] = [])).push(curr);
              return all;
            }, {})
          );
        setCriterias(transform(data.getIQACDatas.Iqacs));
      }
    }
  }, [data, loading, error]);

  return (
    <>
      <MKBox
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${innerCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
        className="innerCover"
      >
        <MKTypography
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["2xl"],
            },
          })}
        >
          Criteria Wise Incharges
        </MKTypography>
      </MKBox>
      <Card
        sx={{
          p: { xs: 2, lg: 8 },
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          {loading ? (
            <img alt="loader" src={loader} className="loader" />
          ) : (
            <Grid container spacing={3} alignItems="center">
              {criterias.map((criteria, index) => (
                <Grid item xs={12} lg={4} md={6}>
                  <div className="card criteria-card">
                    <MKBox display="flex" alignItems="center" p={1}>
                      <MKBox
                        variant="gradient"
                        bgColor="warning"
                        color="white"
                        coloredShadow="warning"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="xl"
                        sx={{ p: 0.5 }}
                      >
                        <HistoryEduIcon />
                      </MKBox>
                      <MKTypography
                        pl={1}
                        variant="h5"
                        sx={({ breakpoints, typography: { size } }) => ({
                          [breakpoints.down("md")]: {
                            fontSize: size["2xl"],
                          },
                        })}
                      >
                        {`CRITERIA ${index + 1} - ${criteria[0].criteria_type} `}
                      </MKTypography>
                    </MKBox>

                    {criteria.map((crtieriaDatas) => (
                      <MKTypography component="a" variant="body2" color="info">
                        <MKBox display="flex" alignItems="center" p={1}>
                          <NameText variant="body2" color="text" pl={5}>
                            {crtieriaDatas.member_name}
                          </NameText>
                        </MKBox>
                      </MKTypography>
                    ))}
                  </div>
                </Grid>
              ))}
              {criterias.length === 0 ? (
                <Grid container spacing={2}>
                  <Grid item md={12} mt={3} sx={{ display: "flex", justifyContent: "center" }}>
                    <MKTypography variant="h3">No Result Found</MKTypography>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          )}
        </Container>
      </Card>
    </>
  );
}

export default CriteriaWiseInCharges;
